import baseInfo from './base-info'
import cms from './cms'
import crm from './crm'
import site from './site'
import fileAndDocuments from './file-and-documents'

export default {
  name: 'SiteGenerator',
  path: 'site-generator',
  meta: {
    label: 'siteGenerator',
    auth: 'site'
  },
  component: {
    name: 'SiteGenerator',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    baseInfo,
    cms,
    crm,
    site,
    fileAndDocuments
  ]
}
